module.exports = __webpack_public_path__ + "static/media/all-about-the-people-02@2x.23ed70d8.png";